import { render } from "./RequestToChangeName.vue?vue&type=template&id=4ad46f7e&scoped=true"
import script from "./RequestToChangeName.vue?vue&type=script&lang=js"
export * from "./RequestToChangeName.vue?vue&type=script&lang=js"

import "./RequestToChangeName.vue?vue&type=style&index=0&id=4ad46f7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad46f7e"]])

export default __exports__